import { render, staticRenderFns } from "./Article7Content.vue?vue&type=template&id=316d653b&scoped=true"
var script = {}
import style0 from "./Article7Content.vue?vue&type=style&index=0&id=316d653b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d653b",
  null
  
)

export default component.exports